import React, { createContext, useContext, useRef, useState } from "react"

const VariableContext = createContext()

export const VariableProvider = ({ children }) => {
    const [locationOptions, setLocationOptions] = useState([])
    const [edcOptions, setEdcOptions] = useState([])
    const [transferSourceOptions, setTransferSourceOptions] = useState([])
    const [locationId, setLocationId] = useState('')
    const [locationName, setLocationName] = useState('')
    const [userId, setUserId] = useState('')
    const [username, setUsername] = useState('')
    const [name, setName] = useState('')
    const [isAdmin, setIsAdmin] = useState('')

    const setVariableLocationOptions = (options) => {
        setLocationOptions(options)
    }
    const setVariableEdcOptions = (options) => {
        setEdcOptions(options)
    }
    const setVariableTransferSourceOptions = (options) => {
        setTransferSourceOptions(options)
    }
    const setVariableLocationId = (value) => {
        setLocationId(value)
    }
    const setVariableLocationName = (value) => {
        setLocationName(value)
    }
    const setVariableUserId = (value) => {
        setUserId(value)
    }
    const setVariableUsername = (value) => {
        setUsername(value)
    }
    const setVariableName = (value) => {
        setName(value)
    }
    const setVariableIsAdmin = (value) => {
        setIsAdmin(value)
    }

    return (
        <VariableContext.Provider
            value={{
                locationOptions,
                edcOptions,
                transferSourceOptions,
                locationId,
                locationName,
                userId,
                username, 
                name,
                isAdmin,
                setVariableLocationOptions,
                setVariableEdcOptions,
                setVariableTransferSourceOptions,
                setVariableLocationId,
                setVariableUserId,
                setVariableLocationName,
                setVariableUsername,
                setVariableName,
                setVariableIsAdmin
            }}
        >
            {children}
        </VariableContext.Provider>
    )
}

export const useVariable = () => useContext(VariableContext)